var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13917_9179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91306 18.8859L16.9132 10.8857L13.1133 7.08578L5.11312 15.086C5.00298 15.1962 4.92475 15.3343 4.88671 15.4854L4 19.999L8.51275 19.1123C8.66426 19.0744 8.80286 18.9961 8.91306 18.8859ZM19.4959 8.30307C19.8187 7.98019 20 7.54233 20 7.08578C20 6.62923 19.8187 6.19137 19.4959 5.86849L18.1305 4.50313C17.8077 4.18035 17.3698 3.99902 16.9132 3.99902C16.4567 3.99902 16.0188 4.18035 15.696 4.50313L14.3306 5.86849L18.1305 9.66843L19.4959 8.30307Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13917_9179)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C5C8CA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGray);
export default __webpack_public_path__ + "static/media/EditGray.1eb1f136057c84b57a93d86aa84e2894.svg";
export { ForwardRef as ReactComponent };